var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhitePhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4346 17.0329L18.4556 13.9529C18.2635 13.8046 18.0238 13.7314 17.7816 13.747C17.5393 13.7627 17.3111 13.8661 17.1396 14.0379L15.0276 16.1509C14.8703 16.3098 14.664 16.4109 14.442 16.438C14.2201 16.465 13.9955 16.4163 13.8046 16.2999C13.1246 15.8829 11.9866 15.0749 10.5626 13.6499C9.13862 12.2269 8.33062 11.0879 7.91362 10.4089C7.79699 10.2182 7.74833 9.99359 7.77556 9.77171C7.8028 9.54983 7.90432 9.3437 8.06362 9.18686L10.1756 7.07386C10.3476 6.90246 10.4511 6.67411 10.4666 6.43175C10.4821 6.1894 10.4085 5.94975 10.2596 5.75786L7.18062 1.77786C6.48062 0.874862 5.16062 0.731862 4.30062 1.48686C3.16762 2.48086 1.80662 3.96986 1.41062 5.64086C0.693621 8.65086 1.82662 12.4279 6.80662 17.4079C11.7866 22.3869 15.5636 23.5209 18.5726 22.8049C20.2436 22.4069 21.7336 21.0449 22.7276 19.9129C23.4816 19.0529 23.3386 17.7329 22.4346 17.0329Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePhone);
export default __webpack_public_path__ + "static/media/whitePhone.6f72d33f05efe4cc9f8a5c7d8ad3a4b7.svg";
export { ForwardRef as ReactComponent };